import { t as o } from "./toNumber.js";
var n = o;
function a(i) {
  return function(t, r) {
    return typeof t == "string" && typeof r == "string" || (t = n(t), r = n(r)), i(t, r);
  };
}
var f = a;
export {
  f as _
};
//# sourceMappingURL=_createRelationalOperation.js.map
